// Colours for the oncoprint heatmap feature
// viridis comes from matplotlib's default colour set, created by Stéfan van der Walt and Nathaniel Smith

import { RGBAColor } from './oncoprintruleset';

export default {
    viridis: [
        [68.08602, 1.24287, 84.000825, 1.0],
        [68.47005, 2.449275, 85.533885, 1.0],
        [68.83572, 3.729375, 87.051645, 1.0],
        [69.182775, 5.08521, 88.553595, 1.0],
        [69.51147, 6.518565, 90.038715, 1.0],
        [69.821295, 8.031735, 91.507515, 1.0],
        [70.11276, 9.62676, 92.958465, 1.0],
        [70.38561, 11.262585, 94.39182, 1.0],
        [70.63959, 12.83772, 95.807325, 1.0],
        [70.874955, 14.36262, 97.203705, 1.0],
        [71.091705, 15.846975, 98.58096, 1.0],
        [71.28933, 17.29818, 99.938835, 1.0],
        [71.468085, 18.721335, 101.276565, 1.0],
        [71.62797, 20.121285, 102.593895, 1.0],
        [71.76873, 21.5016, 103.89057, 1.0],
        [71.89062, 22.86483, 105.165825, 1.0],
        [71.993385, 24.213525, 106.419405, 1.0],
        [72.07728, 25.54998, 107.6508, 1.0],
        [72.14205, 26.875215, 108.86001, 1.0],
        [72.188205, 28.191015, 110.04627, 1.0],
        [72.215235, 29.4984, 111.209325, 1.0],
        [72.223395, 30.798135, 112.34892, 1.0],
        [72.212685, 32.09124, 113.4648, 1.0],
        [72.18336, 33.378225, 114.556455, 1.0],
        [72.13542, 34.6596, 115.623885, 1.0],
        [72.068865, 35.93613, 116.666835, 1.0],
        [71.98395, 37.20756, 117.68505, 1.0],
        [71.881185, 38.474655, 118.678275, 1.0],
        [71.76006, 39.73767, 119.646255, 1.0],
        [71.62134, 40.996605, 120.589245, 1.0],
        [71.465025, 42.251715, 121.50699, 1.0],
        [71.29137, 43.502745, 122.399235, 1.0],
        [71.10063, 44.74995, 123.266235, 1.0],
        [70.89306, 45.993585, 124.107735, 1.0],
        [70.66917, 47.23314, 124.92399, 1.0],
        [70.42947, 48.46887, 125.715255, 1.0],
        [70.173705, 49.700775, 126.481275, 1.0],
        [69.90264, 50.928855, 127.222305, 1.0],
        [69.61653, 52.1526, 127.938855, 1.0],
        [69.31614, 53.372265, 128.63067, 1.0],
        [69.001725, 54.587595, 129.29826, 1.0],
        [68.67354, 55.79859, 129.942135, 1.0],
        [68.33184, 57.004995, 130.56204, 1.0],
        [67.9779, 58.20681, 131.158995, 1.0],
        [67.611975, 59.40378, 131.732745, 1.0],
        [67.234065, 60.595905, 132.28431, 1.0],
        [66.84519, 61.78293, 132.813435, 1.0],
        [66.445605, 62.96511, 133.32114, 1.0],
        [66.036075, 64.141935, 133.80768, 1.0],
        [65.61711, 65.31315, 134.273565, 1.0],
        [65.189475, 66.479265, 134.71956, 1.0],
        [64.753425, 67.63977, 135.145665, 1.0],
        [64.30947, 68.794665, 135.552645, 1.0],
        [63.858375, 69.94395, 135.941265, 1.0],
        [63.400395, 71.087625, 136.31178, 1.0],
        [62.936805, 72.225435, 136.664955, 1.0],
        [62.46786, 73.357125, 137.0013, 1.0],
        [61.993815, 74.48346, 137.32158, 1.0],
        [61.515435, 75.603675, 137.625795, 1.0],
        [61.03323, 76.718025, 137.91522, 1.0],
        [60.547455, 77.82651, 138.189855, 1.0],
        [60.05913, 78.929385, 138.45072, 1.0],
        [59.568765, 80.02614, 138.69807, 1.0],
        [59.07687, 81.11703, 138.93267, 1.0],
        [58.583445, 82.202055, 139.15503, 1.0],
        [58.08951, 83.28147, 139.36566, 1.0],
        [57.595065, 84.355275, 139.56507, 1.0],
        [57.100875, 85.42347, 139.753515, 1.0],
        [56.607195, 86.486055, 139.93176, 1.0],
        [56.114535, 87.543285, 140.100315, 1.0],
        [55.62315, 88.59516, 140.25969, 1.0],
        [55.13355, 89.641425, 140.409885, 1.0],
        [54.64599, 90.682845, 140.55192, 1.0],
        [54.160725, 91.719165, 140.68605, 1.0],
        [53.678265, 92.750385, 140.81253, 1.0],
        [53.198865, 93.77676, 140.932125, 1.0],
        [52.72278, 94.79829, 141.044835, 1.0],
        [52.250265, 95.81523, 141.150915, 1.0],
        [51.781065, 96.82758, 141.250875, 1.0],
        [51.315945, 97.83585, 141.34497, 1.0],
        [50.85465, 98.839785, 141.43371, 1.0],
        [50.39718, 99.83964, 141.517095, 1.0],
        [49.9443, 100.835415, 141.59538, 1.0],
        [49.4955, 101.827365, 141.669075, 1.0],
        [49.051035, 102.815745, 141.73818, 1.0],
        [48.610905, 103.800555, 141.802695, 1.0],
        [48.175365, 104.78205, 141.86313, 1.0],
        [47.743905, 105.76023, 141.919485, 1.0],
        [47.31678, 106.73535, 141.972015, 1.0],
        [46.89399, 107.707665, 142.02072, 1.0],
        [46.47528, 108.67692, 142.0656, 1.0],
        [46.060395, 109.643625, 142.10691, 1.0],
        [45.649845, 110.60778, 142.14465, 1.0],
        [45.242865, 111.569385, 142.179075, 1.0],
        [44.839455, 112.52895, 142.209675, 1.0],
        [44.43987, 113.48622, 142.23696, 1.0],
        [44.043345, 114.441705, 142.260675, 1.0],
        [43.64988, 115.39515, 142.281075, 1.0],
        [43.25973, 116.34681, 142.29765, 1.0],
        [42.87213, 117.29694, 142.31091, 1.0],
        [42.487335, 118.24554, 142.320345, 1.0],
        [42.104835, 119.192865, 142.325955, 1.0],
        [41.724375, 120.138915, 142.32774, 1.0],
        [41.34621, 121.08369, 142.3257, 1.0],
        [40.969575, 122.0277, 142.319325, 1.0],
        [40.59447, 122.970435, 142.308615, 1.0],
        [40.220895, 123.91266, 142.293315, 1.0],
        [39.84885, 124.85412, 142.27368, 1.0],
        [39.477825, 125.794815, 142.2492, 1.0],
        [39.10782, 126.735, 142.21962, 1.0],
        [38.73909, 127.674675, 142.184685, 1.0],
        [38.37138, 128.614095, 142.14465, 1.0],
        [38.004945, 129.553005, 142.09875, 1.0],
        [37.639785, 130.491915, 142.047495, 1.0],
        [37.2759, 131.430315, 141.989865, 1.0],
        [36.913545, 132.368715, 141.92586, 1.0],
        [36.552465, 133.307115, 141.855225, 1.0],
        [36.193425, 134.245515, 141.777705, 1.0],
        [35.83668, 135.18366, 141.693045, 1.0],
        [35.482485, 136.12206, 141.60099, 1.0],
        [35.13135, 137.06046, 141.50103, 1.0],
        [34.78404, 137.999115, 141.393165, 1.0],
        [34.44183, 138.937515, 141.277395, 1.0],
        [34.104465, 139.876425, 141.152955, 1.0],
        [33.77322, 140.81508, 141.01959, 1.0],
        [33.44886, 141.754245, 140.877045, 1.0],
        [33.132915, 142.69341, 140.72532, 1.0],
        [32.825895, 143.632575, 140.563395, 1.0],
        [32.52984, 144.571995, 140.39178, 1.0],
        [32.245515, 145.511415, 140.209455, 1.0],
        [31.97547, 146.45109, 140.01693, 1.0],
        [31.720725, 147.39051, 139.813185, 1.0],
        [31.483065, 148.330185, 139.598475, 1.0],
        [31.26453, 149.269605, 139.372035, 1.0],
        [31.066905, 150.209025, 139.133865, 1.0],
        [30.89274, 151.148445, 138.883455, 1.0],
        [30.744075, 152.08761, 138.620805, 1.0],
        [30.62346, 153.02652, 138.34515, 1.0],
        [30.53319, 153.965175, 138.057, 1.0],
        [30.47556, 154.90332, 137.75559, 1.0],
        [30.452865, 155.840955, 137.44041, 1.0],
        [30.468165, 156.778335, 137.11146, 1.0],
        [30.523245, 157.71495, 136.768485, 1.0],
        [30.620655, 158.651055, 136.41123, 1.0],
        [30.76269, 159.58614, 136.03944, 1.0],
        [30.9519, 160.52046, 135.653115, 1.0],
        [31.18956, 161.454015, 135.25149, 1.0],
        [31.47822, 162.386295, 134.834565, 1.0],
        [31.8189, 163.317555, 134.40234, 1.0],
        [32.21313, 164.247285, 133.954305, 1.0],
        [32.662185, 165.175995, 133.490205, 1.0],
        [33.167085, 166.10292, 133.01004, 1.0],
        [33.72834, 167.02857, 132.513555, 1.0],
        [34.34646, 167.95218, 132.000495, 1.0],
        [35.021445, 168.87426, 131.470605, 1.0],
        [35.75355, 169.794045, 130.923885, 1.0],
        [36.542265, 170.712045, 130.359825, 1.0],
        [37.38708, 171.62775, 129.77868, 1.0],
        [38.28774, 172.540905, 129.180195, 1.0],
        [39.24297, 173.451765, 128.56386, 1.0],
        [40.252005, 174.360075, 127.92993, 1.0],
        [41.31408, 175.26558, 127.277895, 1.0],
        [42.427665, 176.16828, 126.60801, 1.0],
        [43.59174, 177.06792, 125.919765, 1.0],
        [44.805285, 177.9645, 125.213415, 1.0],
        [46.066515, 178.85751, 124.488195, 1.0],
        [47.374665, 179.747205, 123.744615, 1.0],
        [48.72795, 180.63333, 122.98242, 1.0],
        [50.125605, 181.515885, 122.201355, 1.0],
        [51.565845, 182.39436, 121.40142, 1.0],
        [53.04765, 183.268755, 120.582615, 1.0],
        [54.57, 184.13907, 119.74494, 1.0],
        [56.13162, 185.004795, 118.88763, 1.0],
        [57.731235, 185.86644, 118.011195, 1.0],
        [59.367825, 186.722985, 117.115635, 1.0],
        [61.04037, 187.57494, 116.20044, 1.0],
        [62.74785, 188.42205, 115.26612, 1.0],
        [64.489245, 189.263805, 114.31242, 1.0],
        [66.263535, 190.10046, 113.339085, 1.0],
        [68.069955, 190.931505, 112.346115, 1.0],
        [69.907995, 191.75694, 111.333255, 1.0],
        [71.776635, 192.576765, 110.30076, 1.0],
        [73.674855, 193.39047, 109.24863, 1.0],
        [75.602145, 194.198055, 108.176865, 1.0],
        [77.55774, 194.99952, 107.085465, 1.0],
        [79.540875, 195.79461, 105.97443, 1.0],
        [81.551295, 196.58307, 104.84376, 1.0],
        [83.58798, 197.3649, 103.6932, 1.0],
        [85.650675, 198.13959, 102.522495, 1.0],
        [87.73887, 198.907395, 101.332155, 1.0],
        [89.8518, 199.667805, 100.12218, 1.0],
        [91.988955, 200.42082, 98.89257, 1.0],
        [94.14957, 201.16644, 97.64307, 1.0],
        [96.333645, 201.904155, 96.374445, 1.0],
        [98.540415, 202.63422, 95.08593, 1.0],
        [100.76937, 203.356125, 93.778035, 1.0],
        [103.020255, 204.070125, 92.45076, 1.0],
        [105.292815, 204.775455, 91.103595, 1.0],
        [107.58654, 205.47237, 89.73705, 1.0],
        [109.900665, 206.160615, 88.35138, 1.0],
        [112.234935, 206.84019, 86.946585, 1.0],
        [114.58884, 207.51084, 85.52292, 1.0],
        [116.96187, 208.172565, 84.080385, 1.0],
        [119.353515, 208.824855, 82.61949, 1.0],
        [121.76352, 209.46822, 81.139725, 1.0],
        [124.19163, 210.101895, 79.641855, 1.0],
        [126.636825, 210.72588, 78.126135, 1.0],
        [129.099105, 211.34043, 76.59231, 1.0],
        [131.57796, 211.94529, 75.041145, 1.0],
        [134.07288, 212.540205, 73.472385, 1.0],
        [136.583355, 213.125175, 71.88654, 1.0],
        [139.10862, 213.699945, 70.28463, 1.0],
        [141.64842, 214.26477, 68.666655, 1.0],
        [144.20199, 214.81965, 67.033635, 1.0],
        [146.768565, 215.36433, 65.385825, 1.0],
        [149.34789, 215.898555, 63.723735, 1.0],
        [151.938945, 216.422835, 62.048895, 1.0],
        [154.541475, 216.936915, 60.36156, 1.0],
        [157.154715, 217.440795, 58.66326, 1.0],
        [159.777645, 217.934475, 56.955015, 1.0],
        [162.41001, 218.41821, 55.2381, 1.0],
        [165.050535, 218.892, 53.514555, 1.0],
        [167.69871, 219.355845, 51.78591, 1.0],
        [170.35377, 219.809745, 50.054715, 1.0],
        [173.014695, 220.25421, 48.323265, 1.0],
        [175.68072, 220.68924, 46.594875, 1.0],
        [178.350825, 221.114835, 44.872605, 1.0],
        [181.02399, 221.531505, 43.160535, 1.0],
        [183.699705, 221.93925, 41.463765, 1.0],
        [186.376695, 222.33858, 39.787395, 1.0],
        [189.05394, 222.729495, 38.138055, 1.0],
        [191.73042, 223.112505, 36.52314, 1.0],
        [194.405115, 223.48812, 34.95132, 1.0],
        [197.07726, 223.85634, 33.432795, 1.0],
        [199.745325, 224.217675, 31.978275, 1.0],
        [202.4088, 224.57289, 30.601275, 1.0],
        [205.06641, 224.92173, 29.316075, 1.0],
        [207.71688, 225.265215, 28.138485, 1.0],
        [210.3597, 225.6036, 27.085335, 1.0],
        [212.99385, 225.937395, 26.17473, 1.0],
        [215.618055, 226.26711, 25.42401, 1.0],
        [218.23155, 226.593255, 24.85026, 1.0],
        [220.833315, 226.91634, 24.468015, 1.0],
        [223.42284, 227.236875, 24.28875, 1.0],
        [225.999105, 227.55537, 24.32037, 1.0],
        [228.5616, 227.87208, 24.565425, 1.0],
        [231.109305, 228.188025, 25.021875, 1.0],
        [233.64171, 228.503205, 25.682835, 1.0],
        [236.15703, 228.81915, 26.538105, 1.0],
        [238.65552, 229.13535, 27.573405, 1.0],
        [241.13718, 229.452825, 28.77369, 1.0],
        [243.6015, 229.771575, 30.12264, 1.0],
        [246.04797, 230.092365, 31.604955, 1.0],
        [248.476335, 230.41545, 33.204825, 1.0],
        [250.88634, 230.741085, 34.908735, 1.0],
        [253.27824, 231.070035, 36.70368, 1.0],
    ],
    inferno: [
        [0.37281, 0.11883, 3.53583, 1.0],
        [0.578085, 0.32385, 4.73535, 1.0],
        [0.841245, 0.573495, 6.180945, 1.0],
        [1.159485, 0.86496, 7.881795, 1.0],
        [1.53153, 1.19646, 9.83229, 1.0],
        [1.95738, 1.56468, 11.94318, 1.0],
        [2.438055, 1.966815, 14.061465, 1.0],
        [2.974065, 2.401335, 16.1823, 1.0],
        [3.568725, 2.862375, 18.32481, 1.0],
        [4.223055, 3.34968, 20.47191, 1.0],
        [4.940115, 3.858915, 22.635585, 1.0],
        [5.723985, 4.385745, 24.818385, 1.0],
        [6.577215, 4.929405, 27.01215, 1.0],
        [7.50516, 5.483265, 29.228355, 1.0],
        [8.513175, 6.04401, 31.466235, 1.0],
        [9.60534, 6.609855, 33.71916, 1.0],
        [10.774515, 7.175445, 35.990955, 1.0],
        [11.963325, 7.73262, 38.29182, 1.0],
        [13.16922, 8.28087, 40.60977, 1.0],
        [14.394495, 8.815095, 42.94557, 1.0],
        [15.6417, 9.33045, 45.29871, 1.0],
        [16.914405, 9.81852, 47.67531, 1.0],
        [18.214395, 10.27497, 50.07027, 1.0],
        [19.542435, 10.685775, 52.478745, 1.0],
        [20.90031, 11.04864, 54.898695, 1.0],
        [22.289805, 11.36178, 57.327315, 1.0],
        [23.71245, 11.623665, 59.76129, 1.0],
        [25.16901, 11.83251, 62.19552, 1.0],
        [26.660505, 11.98704, 64.62465, 1.0],
        [28.18668, 12.086745, 67.04256, 1.0],
        [29.74728, 12.13137, 69.441855, 1.0],
        [31.34154, 12.12168, 71.81412, 1.0],
        [32.967675, 12.059715, 74.15094, 1.0],
        [34.62339, 11.94828, 76.44288, 1.0],
        [36.30639, 11.79171, 78.681015, 1.0],
        [38.013615, 11.59434, 80.856675, 1.0],
        [39.74175, 11.362545, 82.96119, 1.0],
        [41.485695, 11.10627, 84.985635, 1.0],
        [43.241625, 10.834695, 86.92287, 1.0],
        [45.005715, 10.55751, 88.768305, 1.0],
        [46.774395, 10.283895, 90.517605, 1.0],
        [48.543585, 10.023795, 92.168985, 1.0],
        [50.310735, 9.792, 93.721425, 1.0],
        [52.073295, 9.59616, 95.17569, 1.0],
        [53.829225, 9.44265, 96.533565, 1.0],
        [55.576995, 9.336825, 97.79811, 1.0],
        [57.314565, 9.283275, 98.972895, 1.0],
        [59.04219, 9.283275, 100.062, 1.0],
        [60.759615, 9.338355, 101.070015, 1.0],
        [62.466585, 9.449025, 102.001785, 1.0],
        [64.1631, 9.614775, 102.86139, 1.0],
        [65.84967, 9.835605, 103.653675, 1.0],
        [67.52655, 10.109985, 104.382975, 1.0],
        [69.193485, 10.43511, 105.05388, 1.0],
        [70.85175, 10.800015, 105.66996, 1.0],
        [72.501855, 11.202915, 106.23504, 1.0],
        [74.144565, 11.63922, 106.752435, 1.0],
        [75.78039, 12.10485, 107.225205, 1.0],
        [77.40984, 12.59598, 107.65641, 1.0],
        [79.033425, 13.108785, 108.048855, 1.0],
        [80.65191, 13.63995, 108.40458, 1.0],
        [82.26555, 14.18667, 108.726135, 1.0],
        [83.874855, 14.745885, 109.015305, 1.0],
        [85.480335, 15.3153, 109.27362, 1.0],
        [87.0825, 15.892875, 109.503375, 1.0],
        [88.681605, 16.47708, 109.705335, 1.0],
        [90.27816, 17.065875, 109.88103, 1.0],
        [91.87242, 17.657985, 110.031735, 1.0],
        [93.464895, 18.252645, 110.15847, 1.0],
        [95.05584, 18.848325, 110.262, 1.0],
        [96.645255, 19.444515, 110.343345, 1.0],
        [98.23314, 20.040705, 110.403525, 1.0],
        [99.820515, 20.636385, 110.442795, 1.0],
        [101.40687, 21.230535, 110.461665, 1.0],
        [102.99297, 21.8229, 110.460645, 1.0],
        [104.578815, 22.41348, 110.43999, 1.0],
        [106.164405, 23.001765, 110.400465, 1.0],
        [107.749995, 23.587755, 110.34207, 1.0],
        [109.33584, 24.17145, 110.26506, 1.0],
        [110.921685, 24.752595, 110.169945, 1.0],
        [112.507785, 25.33119, 110.05647, 1.0],
        [114.09414, 25.907235, 109.9254, 1.0],
        [115.681005, 26.48124, 109.77699, 1.0],
        [117.268125, 27.052695, 109.61073, 1.0],
        [118.8555, 27.62211, 109.426875, 1.0],
        [120.44364, 28.189485, 109.22517, 1.0],
        [122.03229, 28.75482, 109.006125, 1.0],
        [123.621195, 29.31837, 108.76974, 1.0],
        [125.21061, 29.880645, 108.51576, 1.0],
        [126.800535, 30.441645, 108.24444, 1.0],
        [128.390715, 31.001625, 107.95578, 1.0],
        [129.98115, 31.561095, 107.64978, 1.0],
        [131.571585, 32.1198, 107.326185, 1.0],
        [133.16253, 32.67825, 106.984995, 1.0],
        [134.75322, 33.236955, 106.62621, 1.0],
        [136.344165, 33.79617, 106.250085, 1.0],
        [137.9346, 34.355895, 105.856365, 1.0],
        [139.525035, 34.916895, 105.445305, 1.0],
        [141.11496, 35.47917, 105.016395, 1.0],
        [142.70412, 36.04323, 104.56989, 1.0],
        [144.29277, 36.609585, 104.10579, 1.0],
        [145.880655, 37.178235, 103.624095, 1.0],
        [147.46752, 37.749945, 103.124805, 1.0],
        [149.052855, 38.32497, 102.608175, 1.0],
        [150.63717, 38.903565, 102.07395, 1.0],
        [152.2197, 39.48624, 101.521875, 1.0],
        [153.800445, 40.073505, 100.952205, 1.0],
        [155.37915, 40.66587, 100.365195, 1.0],
        [156.955815, 41.263335, 99.760845, 1.0],
        [158.529675, 41.86692, 99.139155, 1.0],
        [160.100985, 42.476625, 98.50038, 1.0],
        [161.66949, 43.09296, 97.84452, 1.0],
        [163.234425, 43.71669, 97.171575, 1.0],
        [164.7963, 44.34807, 96.481545, 1.0],
        [166.354095, 44.987355, 95.77443, 1.0],
        [167.908065, 45.63531, 95.05074, 1.0],
        [169.4577, 46.292445, 94.31073, 1.0],
        [171.002745, 46.959015, 93.554145, 1.0],
        [172.54269, 47.635785, 92.781495, 1.0],
        [174.07728, 48.322755, 91.993035, 1.0],
        [175.606515, 49.020945, 91.188765, 1.0],
        [177.129885, 49.730355, 90.36894, 1.0],
        [178.64688, 50.452005, 89.533815, 1.0],
        [180.1575, 51.18564, 88.683135, 1.0],
        [181.66098, 51.93228, 87.817665, 1.0],
        [183.15732, 52.69218, 86.937405, 1.0],
        [184.646265, 53.46585, 86.04312, 1.0],
        [186.126795, 54.253545, 85.134555, 1.0],
        [187.599165, 55.05603, 84.212475, 1.0],
        [189.062865, 55.87356, 83.27688, 1.0],
        [190.517385, 56.70639, 82.32828, 1.0],
        [191.96247, 57.55503, 81.366675, 1.0],
        [193.39761, 58.419735, 80.39283, 1.0],
        [194.82255, 59.30127, 79.406745, 1.0],
        [196.23678, 60.199635, 78.408675, 1.0],
        [197.640045, 61.115085, 77.39913, 1.0],
        [199.031835, 62.048385, 76.378365, 1.0],
        [200.411895, 62.99928, 75.346635, 1.0],
        [201.779715, 63.96828, 74.30445, 1.0],
        [203.134785, 64.95564, 73.25232, 1.0],
        [204.477105, 65.96187, 72.190245, 1.0],
        [205.80591, 66.98646, 71.11899, 1.0],
        [207.120945, 68.03043, 70.038555, 1.0],
        [208.421955, 69.09327, 68.94945, 1.0],
        [209.70843, 70.175235, 67.851675, 1.0],
        [210.97986, 71.276835, 66.74625, 1.0],
        [212.236245, 72.397815, 65.632665, 1.0],
        [213.477075, 73.538175, 64.51194, 1.0],
        [214.702095, 74.697915, 63.38382, 1.0],
        [215.910795, 75.877545, 62.248815, 1.0],
        [217.10292, 77.0763, 61.10718, 1.0],
        [218.27796, 78.29469, 59.958915, 1.0],
        [219.435915, 79.53246, 58.80453, 1.0],
        [220.57653, 80.78961, 57.644025, 1.0],
        [221.699295, 82.065885, 56.47791, 1.0],
        [222.803955, 83.36103, 55.30593, 1.0],
        [223.890255, 84.6753, 54.12834, 1.0],
        [224.95794, 86.008185, 52.94514, 1.0],
        [226.00701, 87.35943, 51.75684, 1.0],
        [227.036955, 88.729035, 50.56293, 1.0],
        [228.047775, 90.116745, 49.36392, 1.0],
        [229.03896, 91.522305, 48.1593, 1.0],
        [230.010765, 92.94546, 46.94958, 1.0],
        [230.962425, 94.3857, 45.73425, 1.0],
        [231.89445, 95.84328, 44.513565, 1.0],
        [232.80633, 97.31718, 43.287525, 1.0],
        [233.69781, 98.807655, 42.05562, 1.0],
        [234.569145, 100.314195, 40.81785, 1.0],
        [235.419825, 101.836545, 39.574215, 1.0],
        [236.24985, 103.374195, 38.32446, 1.0],
        [237.05922, 104.927145, 37.068585, 1.0],
        [237.847935, 106.494885, 35.806335, 1.0],
        [238.615485, 108.076905, 34.5372, 1.0],
        [239.362125, 109.673205, 33.26169, 1.0],
        [240.087855, 111.283275, 31.979295, 1.0],
        [240.792675, 112.90686, 30.69027, 1.0],
        [241.476075, 114.543705, 29.39436, 1.0],
        [242.13831, 116.1933, 28.09182, 1.0],
        [242.779125, 117.85539, 26.782905, 1.0],
        [243.39903, 119.52972, 25.46787, 1.0],
        [243.99726, 121.21578, 24.147225, 1.0],
        [244.57407, 122.91357, 22.822245, 1.0],
        [245.129715, 124.62258, 21.493695, 1.0],
        [245.663685, 126.34281, 20.163615, 1.0],
        [246.176235, 128.073495, 18.834045, 1.0],
        [246.66711, 129.81489, 17.508045, 1.0],
        [247.136565, 131.56623, 16.18944, 1.0],
        [247.584345, 133.327515, 14.883585, 1.0],
        [248.01045, 135.09849, 13.59762, 1.0],
        [248.41488, 136.8789, 12.33996, 1.0],
        [248.797635, 138.66849, 11.12259, 1.0],
        [249.15846, 140.46675, 9.95775, 1.0],
        [249.49761, 142.273935, 8.907405, 1.0],
        [249.81483, 144.089535, 8.009295, 1.0],
        [250.11012, 145.913295, 7.26954, 1.0],
        [250.383225, 147.74496, 6.69375, 1.0],
        [250.634655, 149.58453, 6.288555, 1.0],
        [250.863645, 151.431495, 6.06135, 1.0],
        [251.070705, 153.28611, 6.01953, 1.0],
        [251.255325, 155.14761, 6.17151, 1.0],
        [251.41776, 157.01625, 6.52596, 1.0],
        [251.55801, 158.891775, 7.09257, 1.0],
        [251.67582, 160.773675, 7.88154, 1.0],
        [251.770935, 162.66195, 8.90358, 1.0],
        [251.84361, 164.5566, 10.17093, 1.0],
        [251.893845, 166.457115, 11.623155, 1.0],
        [251.92113, 168.36375, 13.19625, 1.0],
        [251.925975, 170.27574, 14.873895, 1.0],
        [251.90787, 172.193085, 16.640535, 1.0],
        [251.86707, 174.115785, 18.484695, 1.0],
        [251.80332, 176.04333, 20.39745, 1.0],
        [251.71662, 177.97572, 22.371405, 1.0],
        [251.60697, 179.9127, 24.40197, 1.0],
        [251.474625, 181.854015, 26.485065, 1.0],
        [251.31933, 183.79941, 28.618395, 1.0],
        [251.140575, 185.748885, 30.800175, 1.0],
        [250.939125, 187.702185, 33.029385, 1.0],
        [250.71498, 189.65829, 35.305515, 1.0],
        [250.46814, 191.61771, 37.629075, 1.0],
        [250.199115, 193.579425, 40.000065, 1.0],
        [249.90816, 195.543435, 42.420015, 1.0],
        [249.59553, 197.508975, 44.889435, 1.0],
        [249.261735, 199.47579, 47.410365, 1.0],
        [248.90754, 201.44337, 49.98459, 1.0],
        [248.53269, 203.41146, 52.61466, 1.0],
        [248.13744, 205.379295, 55.303635, 1.0],
        [247.72434, 207.34611, 58.05279, 1.0],
        [247.294665, 209.310375, 60.86493, 1.0],
        [246.850455, 211.271325, 63.74286, 1.0],
        [246.391965, 213.228705, 66.69117, 1.0],
        [245.92047, 215.18124, 69.714705, 1.0],
        [245.441835, 217.12638, 72.81423, 1.0],
        [244.95963, 219.062595, 75.99255, 1.0],
        [244.4736, 220.98912, 79.2591, 1.0],
        [243.99267, 222.902895, 82.61337, 1.0],
        [243.524235, 224.800095, 86.056125, 1.0],
        [243.069825, 226.68021, 89.599095, 1.0],
        [242.64423, 228.53763, 93.234885, 1.0],
        [242.25459, 230.369295, 96.969105, 1.0],
        [241.914165, 232.170615, 100.798695, 1.0],
        [241.63647, 233.936745, 104.719575, 1.0],
        [241.436295, 235.66284, 108.725115, 1.0],
        [241.32996, 237.344055, 112.803585, 1.0],
        [241.332765, 238.975545, 116.94096, 1.0],
        [241.460265, 240.55374, 121.11735, 1.0],
        [241.723935, 242.07609, 125.31363, 1.0],
        [242.133975, 243.541065, 129.5043, 1.0],
        [242.6937, 244.949685, 133.671765, 1.0],
        [243.404895, 246.30348, 137.792055, 1.0],
        [244.26348, 247.605765, 141.850125, 1.0],
        [245.26206, 248.86062, 145.840875, 1.0],
        [246.393495, 250.07289, 149.73753, 1.0],
        [247.64631, 251.24691, 153.54927, 1.0],
        [249.010305, 252.387015, 157.2738, 1.0],
        [250.475535, 253.497795, 160.909335, 1.0],
        [252.03231, 254.58282, 164.45562, 1.0],
    ],
} as { [themeName: string]: RGBAColor[] };
